/*
 * @Author: 赵克强 huohuo625@163.com
 * @Date: 2023-06-12 13:19:44
 * @LastEditors: 赵克强 huohuo625@163.com
 * @LastEditTime: 2023-06-12 13:20:01
 * @FilePath: \zhixing-heyue-erp-front-end-pc\src\utils\bus.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import mitt from "mitt";
const emitter = mitt();
export default emitter;